export default __webpack_public_path__ + "static/media/cert4.d3aaa497.jpg";